import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShop1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "shop-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,12.75v9a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5v-9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.148.75H2.852a.751.751,0,0,0-.733.587L.75,7.5a2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0L21.88,1.337A.749.749,0,0,0,21.148.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,16.5a3,3,0,0,0-6,0v6.75h6Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.25,
			y: 15.75,
			width: 4.5,
			height: 4.5,
			rx: .75,
			ry: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.125,18a.375.375,0,1,1-.375.375A.375.375,0,0,1,16.125,18"
		})
	]
});
export default SvgShop1;
